import React from 'react'
import Offer_1 from '../../../assets/images/home_page_3/offer/01.png'
import { Link } from 'react-router-dom'
const Offer = () => {
    return (
        <>
            <section id="offer-three" className="offer-three-main-block">
                <div className="container-fluid">
                    <div className="offer-three-block">
                        <div className="row g-0 align-items-center">
                            <div className="col-lg-6 col-md-6">
                                <div className="offer-three-img">
                                    <img
                                        src={Offer_1}
                                        className="img-fluid"
                                        alt=""
                                    />
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6">
                                <div className="offer-three-dtls">
                                    <div className="section">
                                        <div className="section-sub-title">Special offer</div>
                                        <h4 className="section-title-three   jakarta-font">
                                            Winter Sale! <br /> Upto <span>50%</span> Off
                                        </h4>
                                        <Link to="#" title="" className="btn btn-secondary">
                                            Shop Now
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default Offer
